import gql from 'graphql-tag';

export default gql`
  query OnboardingFlowPublic($flowName: String!) {
    onboardingFlowPublic(name: $flowName) {
      content
    }
  }
`;
